<template>
	<span
		class="icon-wrapper"
		:class="'icon-' + icon"
		v-if="iconData"
		v-html="iconData"
	>
	</span>
</template>
<script>
import axios from "axios";
export default {
	name: "Icon",
	components: {},
	props: ["icon"],
	data() {
		return {
			iconData: false
		};
	},
	computed: {
		iconSrc() {
			return (
				"/wp-content/plugins/profet-e-learning-modules/assets/dist/images/icons/" +
				this.icon +
				".svg"
			);
		}
	},
	methods: {
		getIconData() {
			axios.get(this.iconSrc).then(response => {
				this.iconData = response.data;
			});
		}
	},
	mounted() {
		this.getIconData();
	}
};
</script>